export const CONTACTMETHOD = "contactMethod";
export const OSLLOANGRADE = "oslLoanGrade";
export const LOANFOREIGNNATIONALLOAN = "loanForeignNationalLoan";
export const NHCTIME = "NHCTime";
export const NHCDATE = "NHCDate";
export const NHC_DATE_TIME = "NHCDateTime";
export const PRE_CONSTRUCTION = "preConstruction";
export const PRE_DRYWALL = "preDrywall";